import { render, staticRenderFns } from "./TipoRecomendacaoManage.vue?vue&type=template&id=3c81c186&scoped=true"
import script from "./TipoRecomendacaoManage.vue?vue&type=script&lang=js"
export * from "./TipoRecomendacaoManage.vue?vue&type=script&lang=js"
import style0 from "./TipoRecomendacaoManage.vue?vue&type=style&index=0&id=3c81c186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c81c186",
  null
  
)

export default component.exports